import axiosInstance, { axiosMultipartFormDataInstance } from './axiosInstance';
import { API_PATH, API_VERSION } from './constants';
const filesUploadService = {
    getFiles: (companyId)=>{
        return axiosInstance.get(
            `/${API_VERSION}/${API_PATH.EXECUTIVE_SUMMARY_DOCUMENT}/${companyId}`
        );
    },
    uploadFiles: (data)=>{
        return axiosMultipartFormDataInstance.post(
            `/${API_VERSION}/${API_PATH.EXECUTIVE_SUMMARY_DOCUMENT}`,data
        );
    },
    deleteFiles: (companyId, data)=>{
        return axiosInstance.post(
            `/${API_VERSION}/${API_PATH.EXECUTIVE_SUMMARY_DOCUMENT}/${companyId}/${API_PATH.DELETE}`,data
        );
    },
}
export default filesUploadService;